import React, { useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    VStack,
    Text,
    Button,
} from '@chakra-ui/react';

const ConfirmReplaceModal = ({
                                 isOpen,
                                 onClose,
                                 fileToReplace,
                                 onConfirmReplace,
                             }: {
    isOpen: boolean;
    onClose: () => void;
    fileToReplace: any | null;
    onConfirmReplace: () => Promise<void>; // updated to async
}) => {
    const [isReplacing, setIsReplacing] = useState(false);

    const handleConfirmReplace = async () => {
        setIsReplacing(true);
        await onConfirmReplace();
        setIsReplacing(false);
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Confirm File Replacement</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text fontWeight="bold">Are you sure you want to replace the following file?</Text>
                    <VStack align="start" mt={4}>
                        <Text>
                            <strong>File Name:</strong> {fileToReplace?.FileName}
                        </Text>
                        <Text>
                            <strong>Property:</strong> {fileToReplace?.Property}
                        </Text>
                        <Text>
                            <strong>Language:</strong> {fileToReplace?.Language}
                        </Text>
                        <Text>
                            <strong>Topic:</strong> {fileToReplace?.Topic}
                        </Text>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" onClick={onClose} isDisabled={isReplacing} mr={3}>
                        Cancel
                    </Button>
                    <Button
                        variant="brand"
                        onClick={handleConfirmReplace}
                        isLoading={isReplacing}
                        isDisabled={isReplacing}
                    >
                        Replace
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ConfirmReplaceModal;
